<template>
  <v-layout align-start>
    <v-flex>
      <v-data-table
        :headers="headers"
        :items="usuarios"
        :search="search"
        class="elevation-1"
      >
        <template v-slot:item.estado="{ item }">
          <v-card-text v-if="item.estado" class="blue--text">Activo</v-card-text>
          <v-card-text v-if="!item.estado" class="red--text">Inactivo</v-card-text>
        </template>

        <template v-slot:item.tipo="{ item }">
          <div v-if="item.tipo">
            <span v-if="item.tipo == 'agencia'">{{ item.agencia.nombre }}</span>
          </div>
        </template>

        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Usuarios</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-text-field
              class="text-xs-center"
              v-model="search"
              append-icon="search"
              label="Busqueda"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="600px" persistent>
              <template v-slot:activator="{ on }">
                <v-btn @click="limpiar" small class="mb-2" v-on="on">Nuevo Usuario</v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-stepper v-model="step" alt-labels>
                      <v-stepper-header>
                        <v-stepper-step :complete="step > 1" step="1">
                          Tipo de Usuario
                        </v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step :complete="step > 2" step="2">
                          Información Personal
                        </v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step step="3"> Datos de Contacto </v-stepper-step>
                      </v-stepper-header>

                      <v-stepper-items>
                        <!-- Paso 1: Tipo de Usuario -->
                        <v-stepper-content step="1">
                          <v-card class="mb-8 pa-3" flat>
                            <v-card-subtitle class="text-subtitle-1 pb-2">
                              <v-icon left color="primary" small
                                >mdi-account-group</v-icon
                              >
                              Selecciona el tipo de usuario
                            </v-card-subtitle>
                            <v-radio-group v-model="tipo_usuario" mandatory class="mt-2">
                              <v-radio value="agencia" class="mb-1">
                                <template v-slot:label>
                                  <div class="d-flex align-center">
                                    <v-icon left color="blue" small
                                      >mdi-office-building</v-icon
                                    >
                                    <div>
                                      <span class="font-weight-medium">Agencia</span>
                                      <div class="text-caption grey--text">
                                        Usuario de agencia marítima
                                      </div>
                                    </div>
                                  </div>
                                </template>
                              </v-radio>
                              <v-radio value="psp" class="mb-1">
                                <template v-slot:label>
                                  <div class="d-flex align-center">
                                    <v-icon left color="green" small>mdi-truck</v-icon>
                                    <div>
                                      <span class="font-weight-medium">Proveedor</span>
                                      <div class="text-caption grey--text">
                                        Proveedor de servicios portuarios
                                      </div>
                                    </div>
                                  </div>
                                </template>
                              </v-radio>
                            </v-radio-group>
                          </v-card>
                          <v-btn
                            color="primary"
                            small
                            :disabled="!tipo_usuario"
                            @click="step = 2"
                          >
                            Continuar
                          </v-btn>
                        </v-stepper-content>

                        <!-- Paso 2: Información Personal -->
                        <v-stepper-content step="2">
                          <v-card class="mb-8 pa-3" flat>
                            <v-card-subtitle class="text-subtitle-1 pb-2">
                              <v-icon left color="primary" small>mdi-account</v-icon>
                              Información Personal
                            </v-card-subtitle>
                            <v-row dense>
                              <v-col cols="12" sm="6">
                                <v-text-field
                                  v-model="nombre"
                                  label="Nombre"
                                  prepend-icon="mdi-account"
                                  :rules="[rules.required, rules.maxLength(50)]"
                                  dense
                                  outlined
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6">
                                <v-select
                                  v-model="rol"
                                  :items="roles"
                                  label="Rol"
                                  prepend-icon="mdi-shield-account"
                                  :rules="[rules.required]"
                                  dense
                                  outlined
                                ></v-select>
                              </v-col>
                              <v-col cols="12" sm="6">
                                <v-text-field
                                  v-model="empresa"
                                  label="Empresa"
                                  prepend-icon="mdi-domain"
                                  :rules="[rules.required, rules.maxLength(100)]"
                                  dense
                                  outlined
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6">
                                <v-text-field
                                  v-model="cargo"
                                  label="Cargo"
                                  prepend-icon="mdi-briefcase"
                                  dense
                                  outlined
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12">
                                <v-autocomplete
                                  v-if="tipo_usuario == 'agencia'"
                                  :items="agencias"
                                  v-model="agencia"
                                  label="Agencia"
                                  prepend-icon="mdi-office-building"
                                  :rules="[rules.required]"
                                  dense
                                  outlined
                                ></v-autocomplete>
                                <v-autocomplete
                                  v-if="tipo_usuario == 'psp'"
                                  :items="psps"
                                  v-model="psp"
                                  label="Proveedor"
                                  prepend-icon="mdi-truck"
                                  :rules="[rules.required]"
                                  dense
                                  outlined
                                ></v-autocomplete>
                              </v-col>
                            </v-row>
                          </v-card>
                          <v-btn text small @click="step = 1" class="mr-2">Atrás</v-btn>
                          <v-btn
                            color="primary"
                            small
                            :disabled="
                              !nombre ||
                              !rol ||
                              !empresa ||
                              (!agencia && tipo_usuario == 'agencia') ||
                              (!psp && tipo_usuario == 'psp')
                            "
                            @click="step = 3"
                          >
                            Continuar
                          </v-btn>
                        </v-stepper-content>

                        <!-- Paso 3: Datos de Contacto -->
                        <v-stepper-content step="3">
                          <v-card class="mb-8 pa-3" flat>
                            <v-card-subtitle class="text-subtitle-1 pb-2">
                              <v-icon left color="primary" small>mdi-contact-mail</v-icon>
                              Contacto y Acceso
                            </v-card-subtitle>
                            <v-row dense>
                              <v-col cols="12" sm="6">
                                <v-text-field
                                  v-model="email"
                                  label="Email"
                                  type="email"
                                  prepend-icon="mdi-email"
                                  :rules="[rules.required, rules.email]"
                                  dense
                                  outlined
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6">
                                <v-text-field
                                  v-model="telefono"
                                  label="Teléfono"
                                  prepend-icon="mdi-phone"
                                  dense
                                  outlined
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12">
                                <v-text-field
                                  v-model="direccion"
                                  label="Dirección"
                                  prepend-icon="mdi-map-marker"
                                  dense
                                  outlined
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12">
                                <v-text-field
                                  v-model="password"
                                  type="password"
                                  label="Contraseña"
                                  prepend-icon="mdi-lock"
                                  :rules="[rules.required, rules.minLength(6)]"
                                  hint="Mínimo 6 caracteres"
                                  dense
                                  outlined
                                ></v-text-field>
                              </v-col>
                            </v-row>
                          </v-card>
                          <v-btn text small @click="step = 2" class="mr-2">Atrás</v-btn>
                          <v-btn
                            color="primary"
                            small
                            :disabled="!email || !password || password.length < 6"
                            @click="guardar"
                          >
                            {{ editedIndex === -1 ? "Crear" : "Actualizar" }}
                          </v-btn>
                        </v-stepper-content>
                      </v-stepper-items>
                    </v-stepper>

                    <!-- Mensajes de validación -->
                    <v-alert
                      v-if="valida && validaMensaje.length"
                      type="error"
                      dismissible
                      class="mt-4"
                    >
                      <div v-for="mensaje in validaMensaje" :key="mensaje">
                        {{ mensaje }}
                      </div>
                    </v-alert>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="adModal" max-width="290">
              <v-card>
                <v-card-title class="headline" v-if="adAccion == 1"
                  >Activar Item</v-card-title
                >
                <v-card-title class="headline" v-if="adAccion == 2"
                  >Desactivar Item</v-card-title
                >

                <v-card-text>
                  Estas a punto de
                  <span v-if="adAccion == 1">Activar</span>
                  <span v-if="adAccion == 2">Desactivar</span>
                  al usuario {{ adNombre }}
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click="activarDesactivarCerrar()" small color="green"
                    >Cancelar</v-btn
                  >
                  <v-btn v-if="adAccion == 1" @click="activar()" small color="blue"
                    >Activar</v-btn
                  >
                  <v-btn v-if="adAccion == 2" @click="desactivar()" small color="red"
                    >Desactivar</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>

        <template v-slot:item.action="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
          <template v-if="item.estado">
            <v-icon small @click="activarDesactivarMostrar(2, item)">block</v-icon>
          </template>

          <template v-else>
            <v-icon small @click="activarDesactivarMostrar(1, item)">check</v-icon>
          </template>
        </template>

        <template v-slot:item.certificado="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">fa fa-file-pdf-o</v-icon>
        </template>

        <template v-slot:no-data>
          <v-btn color="primary" @click="listar()">Resetear</v-btn>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import "font-awesome/css/font-awesome.min.css"; // Ensure you are using css-loader
import swal from "sweetalert";
import emailjs from "emailjs-com";

export default {
  icons: {
    iconfont: "fa4",
  },
  data() {
    return {
      dialog: false,
      step: 1,
      search: "",
      usuarios: [],
      headers: [
        { text: "Actions", value: "action", sortable: false },
        { text: "Nombre", value: "nombre", sortable: true },
        { text: "Empresa", value: "empresa", sortable: true },
        { text: "Email", value: "email", sortable: false },
        { text: "Agencia / Proveedor", value: "tipo", sortable: false },
        { text: "Rol", value: "rol", sortable: true },
        { text: "Telefono", value: "telefono", sortable: true },
        { text: "Estatus", value: "estado", sortable: true },
      ],
      editedIndex: -1,
      _id: "",
      nombre: "",
      agencias: [],
      rol: "",
      roles: [
        "root",
        "Vigilante",
        "Administrador",
        "Agencia",
        "PSP",
        "OPIP",
        "Finanzas",
        "Comercial",
        "Operaciones",
        "Mesa de control",
        "Lectura",
        "Soporte",
        "Autorizador directo",
      ],
      empresa: "",
      email: "",
      direccion: "",
      psps: [],
      psp: "",
      telefono: "",
      tipo_usuario: "",
      cargo: "",
      estado: "",
      password: "",
      agencia: "",
      valida: 0,
      validaMensaje: [],
      adModal: 0,
      adAccion: 0,
      adNombre: "",
      adId: "",
      rules: {
        required: (value) => !!value || "Este campo es requerido",
        email: (value) => {
          const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          return pattern.test(value) || "Email inválido";
        },
        minLength: (min) => (value) =>
          (value && value.length >= min) || `Mínimo ${min} caracteres`,
        maxLength: (max) => (value) =>
          !value || value.length <= max || `Máximo ${max} caracteres`,
      },
    };
  },
  computed: {
    // Título dinámico del formulario según modo de operación (creación/edición)
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo usuario" : "Editar usuario";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  // Inicialización del componente: carga datos necesarios para el sistema de usuarios
  created() {
    this.listar(); // Carga lista de usuarios existentes
    this.selectAgencias(); // Obtiene agencias activas para dropdown
    this.selectPsp(); // Obtiene PSPs activos para dropdown
    this.emailIn(); // Inicializa servicio de email para notificaciones
  },

  methods: {
    // Sistema de validación completa para usuarios del sistema portuario
    validar() {
      this.valida = 0;
      this.validaMensaje = [];

      // Validaciones críticas para la gestión de usuarios
      if (!this.rol) {
        this.validaMensaje.push("El rol es obligatorio"); // Rol determina permisos del sistema
      }
      if (this.empresa.length < 1 || this.empresa.length > 100) {
        this.validaMensaje.push(
          "El nombre de la empresa debe tener entre 1 y 30 caracteres"
        );
      }
      if (this.nombre.length < 1 || this.nombre.length > 50) {
        this.validaMensaje.push(
          "El nombre del usuario debe tener entre 1 y 50 caracteres"
        );
      }
      if (this.email.length < 1 || this.email.length > 50) {
        this.validaMensaje.push("El email debe tener entre 1 y 50 caracteres");
      }
      if (this.password.length < 1 || this.password.length > 64) {
        this.validaMensaje.push("El password debe tener entre 1 y 64 caracteres");
      }

      // Marca formulario como inválido si hay errores
      if (this.validaMensaje.length) {
        this.valida = 1;
      }
      return this.valida;
    },

    // Inicializa servicio EmailJS para notificaciones automáticas a usuarios
    emailIn() {
      emailjs.init("user_QA8qMBuyHCQIHTgR0AsPx"); // Configuración de API key
    },

    // Resetea completamente el formulario multi-step y estados de validación
    limpiar() {
      // Limpia campos de identificación
      this._id = "";
      this.nombre = "";
      this.rol = "";

      // Limpia campos empresariales
      this.empresa = "";
      this.cargo = "";

      // Limpia datos de contacto
      this.email = "";
      this.telefono = "";
      this.direccion = "";
      this.password = "";

      // Limpia asociaciones específicas del sector portuario
      this.tipo_usuario = ""; // agencia o psp
      this.agencia = ""; // ID de agencia marítima
      this.psp = ""; // ID de proveedor de servicios portuarios

      // Resetea estados de validación y navegación
      this.valida = 0;
      this.validaMensaje = [];
      this.editedIndex = -1; // Marca modo creación
      this.step = 1; // Regresa al primer paso del stepper
    },
    // Lógica principal de guardado: maneja creación y edición de usuarios del sistema portuario
    guardar() {
      let me = this;
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };

      if (this.editedIndex > -1) {
        // Modo EDICIÓN: actualiza usuario existente
        axios
          .put(
            "usuario/update",
            {
              _id: this._id,
              nombre: this.nombre,
              rol: this.rol, // Rol del sistema (root, Administrador, Agencia, PSP, etc.)
              empresa: this.empresa,
              email: this.email,
              direccion: this.direccion,
              telefono: this.telefono,
              password: this.password,
              agencia: this.agencia, // ID de agencia marítima asociada
              tipo: this.tipo_usuario, // 'agencia' o 'psp'
              psp: this.psp, // ID de proveedor de servicios portuarios
              cargo: this.cargo, // Cargo dentro de la organización
            },
            configuracion
          )
          .then(function (response) {
            swal("Usuario actualizado", "Usuario actualizado con éxito", "success");
            // Limpieza y actualización de UI
            me.limpiar();
            me.close();
            me.listar();
          })
          .catch(function (error) {
            swal("Error", "Verifica los datos ingresados" + error, "error");
          });
      } else {
        // Modo CREACIÓN: nuevo usuario del sistema
        axios
          .post(
            "usuario/add",
            {
              nombre: this.nombre,
              rol: this.rol,
              empresa: this.empresa,
              email: this.email,
              direccion: this.direccion,
              telefono: this.telefono,
              password: this.password,
              agencia: this.agencia,
              cargo: this.cargo,
              tipo: this.tipo_usuario, // Determina si es usuario de agencia o PSP
              psp: this.psp,
            },
            configuracion
          )
          .then(function (response) {
            swal("Nuevo usuario agregado", "Nuevo usuario agregado con éxito", "success");
            // Limpieza y actualización de UI
            me.limpiar();
            me.close();
            me.listar();
          })
          .catch(function (error) {
            swal("Error", "Verifica los datos ingresados" + error, "error");
          });
      }
    },
    // Obtiene lista completa de usuarios del sistema (activos e inactivos)
    listar() {
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;
      axios
        .get("usuario/list", configuracion)
        .then(function (response) {
          me.usuarios = response.data; // Lista completa para administración
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    // Obtiene solo usuarios activos (para operaciones específicas)
    listarActivos() {
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;
      axios
        .get("usuario/listActivos", configuracion)
        .then(function (response) {
          me.usuarios = response.data; // Solo usuarios habilitados
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    // Carga agencias marítimas activas para asociación con usuarios
    selectAgencias() {
      let me = this;
      let agencaiArray = [];
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("agencia/listActivos", configuracion)
        .then((response) => {
          agencaiArray = response.data;
          // Transforma datos para dropdown con formato {text, value}
          agencaiArray.map(function (x) {
            me.agencias.push({ text: x.nombre, value: x._id });
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    // Carga PSPs (Prestadores de Servicios Portuarios) activos para asociación
    selectPsp() {
      let me = this;
      let configuracion = {
        headers: {
          Authorization: `Bearer ${this.$store.state.token}`,
        },
      };
      axios
        .get("psp/select_psp", configuracion)
        .then((response) => {
          this.psps = response.data; // Lista de proveedores disponibles
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    // Carga datos del usuario seleccionado en el formulario para edición
    editItem(item) {
      // Campos básicos del usuario
      this._id = item._id;
      this.nombre = item.nombre;
      this.empresa = item.empresa;
      this.rol = item.rol; // Rol del sistema portuario
      this.tipo_usuario = item.tipo; // 'agencia' o 'psp'
      this.cargo = item.cargo;

      // Asociaciones específicas del sector marítimo
      if (item.agencia) {
        this.agencia = item.agencia._id; // ID de agencia marítima
      }
      if (item.psp) {
        this.psp = item.psp._id; // ID de proveedor de servicios
      }

      // Datos de contacto
      this.email = item.email;
      this.direccion = item.direccion;
      this.telefono = item.telefono;
      this.password = item.password;

      // Estados de edición y navegación
      this.editedIndex = 1; // Marca modo edición
      this.step = 1; // Inicia desde el primer paso del stepper
      this.dialog = true; // Abre modal de edición
    },

    // Prepara modal de confirmación para activar/desactivar usuarios
    activarDesactivarMostrar(accion, item) {
      this.adModal = 1; // Muestra modal de confirmación
      this.adNombre = item.nombre; // Nombre del usuario para confirmación
      this.adId = item._id; // ID del usuario

      // Define acción: 1=Activar acceso, 2=Desactivar acceso
      if (accion == 1) {
        this.adAccion = 1; // Habilita acceso al sistema
      } else if (accion == 2) {
        this.adAccion = 2; // Deshabilita acceso (soft delete)
      } else {
        this.adMmodal = 0; // Cierra modal si acción inválida
      }
    },
    // Activa un usuario deshabilitado (restaura acceso al sistema)
    activar() {
      let me = this;
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .put("usuario/activate", { _id: this.adId }, configuracion)
        .then(function (response) {
          // Limpia estado del modal y actualiza lista
          me.adModal = 0;
          me.adAccion = 0;
          me.adNombre = "";
          me.adId = "";
          me.listar(); // Refresca tabla con nuevo estado
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    // Desactiva un usuario activo (suspende acceso - soft delete)
    desactivar() {
      let me = this;
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .put("usuario/deactivate", { _id: this.adId }, configuracion)
        .then(function (response) {
          // Limpia estado del modal y actualiza lista
          me.adModal = 0;
          me.adAccion = 0;
          me.adNombre = "";
          me.adId = "";
          me.listar(); // Refresca tabla con nuevo estado
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    activarDesactivarCerrar() {
      this.adModal = 0;
    },

    close() {
      this.dialog = false;
    },
  },
};
</script>
